import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Auth Store - Authentication state management
 * Uses Zustand with persistence for user data only
 * Access token is kept in memory only (not persisted)
 */
const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      user: null,
      accessToken: null,
      isAuthenticated: false,
      isLoading: false,

      // Actions
      setUser: (user) => set({ user, isAuthenticated: !!user }),

      setAccessToken: (token) => set({ accessToken: token }),

      setLoading: (isLoading) => set({ isLoading }),

      login: (user, accessToken) => {
        set({
          user,
          accessToken,
          isAuthenticated: true,
          isLoading: false,
        });
      },

      logout: () => {
        set({
          user: null,
          accessToken: null,
          isAuthenticated: false,
          isLoading: false,
        });
      },

      updateUser: (userData) => {
        set((state) => ({
          user: state.user ? { ...state.user, ...userData } : null,
        }));
      },

      // Getters
      getAccessToken: () => get().accessToken,
      getUser: () => get().user,
      isAdmin: () => get().user?.role === 'admin',
      isDirector: () => get().user?.role === 'director' || get().user?.role === 'admin',
      isSupervisor: () => get().user?.role === 'supervisor' || get().user?.role === 'admin',
      isManager: () => get().user?.role === 'manager',
    }),
    {
      name: 'auth-storage',
      // Only persist user data, NOT the access token
      partialize: (state) => ({ user: state.user }),
    }
  )
);

export default useAuthStore;
